const Landing = () => null;

export default Landing;